module.exports = __webpack_public_path__ + "images/36ebb347e3f33e8d2e221f9b434f0571.png";